import { Upload } from 'hljd'
import React, { Component } from 'react'
import { addChangeAttr, picPrevCheck } from '../../utils'

class UploadImage extends Component {
  onChange(val) {
    this.props.onChange(val)
  }

  render() {
    const { value } = this.props

    return (
      <div style={{ lineHeight: 'initial', marginTop: 9 }}>
        <p style={{ marginBottom: 8 }}>
          可选，如客户聊天截图、搭建视频/图片等。图片大小不能超过50MB
        </p>
        <div>
          <Upload
            // eslint-disable-next-line no-undef
            tokenFrom={{
              image: 'proofMaterialImage'
            }}
            multiple
            accept="image/*"
            upText="点击上传"
            max={50}
            onChange={val => this.onChange(addChangeAttr(val))}
            beforeUpload={picPrevCheck}
            value={value}
          />
        </div>
      </div>
    )
  }
}

export default UploadImage
